import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconTags = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <path d="M11.6435 4.79105C12.065 4.36953 12.6526 4.15801 13.2461 4.21415L17.5662 4.62281C18.5219 4.71321 19.2786 5.46988 19.369 6.42557L19.7776 10.7457C19.8338 11.3392 19.6222 11.9267 19.2007 12.3482L10.971 20.578C10.1899 21.3591 8.92358 21.3591 8.14253 20.578L3.41376 15.8492C2.63271 15.0682 2.63271 13.8019 3.41376 13.0208L11.6435 4.79105Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="14.5952" cy="9.39844" r="1.78125" transform="rotate(135 14.5952 9.39844)" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default IconTags
